import { handleActions, Reducer } from "redux-actions";
import {  
    ACTION_LOGIN_SUCCESS, 
    ACTION_LOGIN_FAILL,
    ACTION_LOGOUT_SUCCESS,
    ACTION_SENDCAPTCHA_SUCCESS,
    ACTION_CHANGEPASSWORD_SUCCESS
} from "../actions/user";

export interface userState {
    accessToken: string
    loginStatus: boolean
    organizationId: any
    name: string | null
    loginFail: any
    invaildLogin: boolean
}

let accessToken: any = localStorage.getItem('accessToken');
let loginStatus: any = localStorage.getItem('status');
let organizationId: any = localStorage.getItem('organizationId');
let name = localStorage.getItem('name');

const defaultState: userState = {
    accessToken: accessToken,
    loginStatus: loginStatus,
    organizationId: organizationId,
    name: name,
    loginFail: {},
    invaildLogin: true
}


function handleActionLoginSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        accessToken: action.payload.accessToken,
        organizationId: action.payload.organizationId,
        name: action.payload.name,
        loginStatus: true,
        invaildLogin: false
    };
}

function handleActionLoginFailSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    localStorage.setItem('status', 'false')
    return {
        ...state,
        loginFail: action.payload,
        loginStatus: false
    };
}

function handleActionLogoutSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        loginStatus: false,
        invaildLogin: action.payload.invaildLogin
    };
}

function handleActionChangePasswordSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

function handleActionSendCaptchaSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

export const userReducer: Reducer<userState, any> = handleActions(
    {
        [ACTION_LOGIN_SUCCESS]: handleActionLoginSuccess,
        [ACTION_LOGIN_FAILL]: handleActionLoginFailSuccess,
        [ACTION_LOGOUT_SUCCESS]: handleActionLogoutSuccess,
        [ACTION_CHANGEPASSWORD_SUCCESS]: handleActionChangePasswordSuccess,
        [ACTION_SENDCAPTCHA_SUCCESS]: handleActionSendCaptchaSuccess
    },
    defaultState
);
